import {Sport} from './common';
import {Manager} from './common';
import {Moderator} from './common';
import {ConversationId} from './matrix';
import {GroupData} from './group';
export interface Participant {
  _id: string;
  name: string;
  color: string;
  picture: string;
  gender: string;
  birthday: string;
  updatedAt: string;
  email: string;
  description?: string;
  participant?: string;
}
export interface SportsData {
  [key: string]: Sport;
}

export interface SportEvent {
  sport: Sport;
  _id: string;
}

export interface EventData {
  _id: string;
  title: string;
  description: string;
  sports: {
    sport: Sport;
    _id: string;
  }[];
  start: Date;
  end: Date;
  locationName: string;
  createdBy: {
    _id: string;
    name: string;
    email: string;
  };
  participants: Participant[];
  managers: Manager[];
  moderators: Moderator[];
  geolocation: {
    coordinates: number[];
    type: string;
    timezone: string;
  };
  ageGroups: Array<string>;
  group: GroupData;
  recurring: Array<number>;
  online: boolean;
  accessType: 'PUBLIC' | 'PRIVATE';
  dist: {
    calculated: number;
  } | null;
  status: 'OPEN' | 'CANCELLED' | 'FULL' | 'CLOSED' | null;
  maxParticipants: number | null;
  companyRole: string | null;
  conversationId: ConversationId;
  isPaid: boolean;
  price: number;
  picture?: string;
  imprintLink?: string;
  termsOfUseLink?: string;
  cancellationPolicyLink?: string;
  currency: string;
  organizerAccountId?: string;
  tag?: string;
  trainerEvent?: boolean;
  company?: string;
  onDemand?: boolean;
  onDemandLink?: string;
}

export type EventFormData = {
  recurring?: number | number[];
  end?: Date;
  title: string;
  online?: boolean;
  description: string;
  accessType: 'PUBLIC' | 'PRIVATE';
  locationName: string;
  coordinates: number[];
  sports: string | SportsData[];
  ageGroups: string[];
  group?: string;
  maxParticipants?: number;
  company?: string;
  isPaid?: boolean;
  price?: number;
  imprintLink?: string;
  termsOfUseLink?: string;
  cancellationPolicyLink?: string;
  picture?: string;
  trainerEvent?: boolean;
};

export enum EventFormMode {
  CREATE = 'CREATE',
  CLONE = 'CLONE',
  UPDATE = 'UPDATE'
}
